import ActionButton from '@/components/actionButton';
import { getNextWorkDay } from '@/lib/utils';
import Link from 'next/link';
import { useState } from 'react';
import CTAPopup from '../cta-popup';

export enum PopupContentType {
  NONE = 'None',
  WHITE_PAPER = 'White paper',
  PIPEDRIVE = 'TestDrive request over pipedrive'
}

export interface PropsIC {
  internalTitle: string;
  buttonText: string;
  buttonUrl: string;
  document: { url: string };
  showTitle: boolean;
  popupContent: PopupContentType;
  apiKey?: string;
  crmUserId?: string;
  activityType?: string;
  subject?: string;
}

interface NavigationButtonProps {
  data: PropsIC;
}

const NavigationButton = ({ data }: NavigationButtonProps) => {
  const [showPopup, setShowPopup] = useState(false);

  const {
    internalTitle,
    buttonText,
    buttonUrl,
    document,
    showTitle = true,
    popupContent = PopupContentType.NONE,
    apiKey,
    crmUserId,
    activityType,
    subject
  } = data || {};
  const isPopupButton = [
    PopupContentType.PIPEDRIVE,
    PopupContentType.WHITE_PAPER
  ].includes(popupContent);

  const optionalPipeDriveData = {
    ...(subject && { subject }),
    ...(activityType && { type: activityType }),
    ...(apiKey && { apiKey }),
    ...(crmUserId && { owner_id: Number(crmUserId) }),
    ...(apiKey && { due_date: getNextWorkDay() }),
    ...(apiKey && { priority: 306 })
  };

  const popupData = {
    internalTitle,
    buttonText,
    onClick: () => setShowPopup(true),
    popupContent,
    showTitle,
    pipedriveData: { ...optionalPipeDriveData }
  };

  return (
    <>
      <div>
        {isPopupButton ? (
          <ActionButton data={popupData} />
        ) : (
          <>
            {internalTitle && showTitle && (
              <h3 className="mb-7">{internalTitle}</h3>
            )}
            {buttonUrl && (
              <Link
                href={document?.url ? document.url : buttonUrl}
                target={`${document?.url ? '_blank' : ''}`}
                className="ml-3 green-button group"
              >
                <p className="group-hover:text-brand-green">{buttonText}</p>
              </Link>
            )}
          </>
        )}
      </div>
      {showPopup && (
        <CTAPopup data={popupData} closeDialog={() => setShowPopup(false)} />
      )}
    </>
  );
};

export default NavigationButton;
